import PropTypes from 'prop-types';
import React from 'react';
/* COMPONENTS */
import { GroupCondensedPropShape } from '../../Includes/GroupPropsShape';
import CommonCardShell from '../../Layout/CommonCardShell/CommonCardShell';

import GroupLogo from '../GroupLogo/GroupLogo';
/* STYLESHEETS */
import './SingleGroup.scss';

export default class SingleGroup extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /** description, groupUrl, hash, logo, name, privacySetting */
        ...GroupCondensedPropShape,
        /**
         * Rules for group membership
         */
        rules: PropTypes.string,
        /**
         * Question asked to users requesting to join the group
         */
        inviteQuestion: PropTypes.string,
    };

    render() {
        const { description, children, groupUrl, logo, name } = this.props;

        return (
            <li className="component-Groups-SingleGroup">
                <CommonCardShell>
                    <a className="logo-container" href={groupUrl}>
                        <GroupLogo logo={logo} name={name} />
                    </a>

                    <a className="name" href={groupUrl}>
                        {name}
                    </a>
                    <hr />
                    <div className="description">{description}</div>

                    {children}
                </CommonCardShell>
            </li>
        );
    }
}
